'use client';

var translations = {
    'Select company industry': 'Chọn lĩnh vực công ty',
    'You have selected the max number of 3 industries': 'Bạn đã lựa chọn tối đa 3 lĩnh vực công ty'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
